import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const authCallbackTexts = {
  de: {
    completingSignIn: 'Anmeldung wird abgeschlossen...',
  },

  en: {
    completingSignIn: 'Completing sign in...',
  },

  no: {
    completingSignIn: 'Fullfører innlogging...',
  },

  ko: {
    completingSignIn: '로그인 완료 중...',
  },

  fi: {
    completingSignIn: 'Viimeistellään kirjautumista...',
  },
};

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const { language } = useLanguage();
  const hasProcessed = useRef(false);

  const text = authCallbackTexts[language] || authCallbackTexts.en;

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(data);
        navigate('/discover', { state: { user: data } });
      } catch (error) {
        console.error('Session processing failed:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white">{text.completingSignIn}</p>
      </div>
    </div>
  );
};

export default AuthCallback;